import React, { useState } from "react";
import axios from "axios";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { range } from "lodash";
import { handleApiError } from "@utils/errorHandler";
import { Dropdown, Image, Anchor } from "hesus-ui-kit";
import Price from "./Price";
import Comment from "./Comment";
import SolutionView from "../../../../Solution/SolutionView";
import cancelIcon from "@icons/ic-cancel.svg";
import greenYesIcon from "@icons/ic-yes-green.svg";

import {
  GridRow,
  OuterDiv,
  GridLabel,
  GridSubLabel,
  IDButton,
  HorizontalRow,
} from "./Solutions.styled";
import "../../KickOffView.scss";

const Solutions = (props) => {
  const {
    t,
    solutionList,
    koStatus,
    isOperationType,
    sellingPriceId,
    setIsRefreshQuoteData,
    isStudyTeamType,
    hesusService,
    combination,
  } = props;

  const [isSolutionViewPopupVisible, setSolutionViewPopupVisibility] =
    useState(false);
  const [currentSolution, setCurrentSolution] = useState(null);

  const checkDisabledStatausOfAllocation = (solutionKoStatus) => {
    if (
      combination &&
      !hesusService?.needProduct &&
      hesusService?.needTransport
    ) {
      return true;
    }
    if (parseFloat(solutionKoStatus, 10) === 1 && isOperationType > 0) {
      return false;
    }

    return true;
  };

  const editSolution = (solutionId) => {
    setSolutionViewPopupVisibility(false);
    axios
      .get(`/solutions/${solutionId}`)
      .then((response) => {
        setCurrentSolution(response.data[0]);
        setSolutionViewPopupVisibility(true);
      })
      .catch((error) => handleApiError(error));
  };

  const onSolutionViewClose = () => {
    setSolutionViewPopupVisibility(false);
  };

  const handleSolutionValidate = (
    e,
    type,
    sellingPriceItemSolutionId,
    allocation
  ) => {
    let data = {
      koStatus: 1,
    };
    if (type === "validate") {
      data = {
        koStatus: 1,
        allocation,
      };
    }
    if (type === "invalidate") {
      data = {
        koStatus: 0,
        allocation,
      };
    }
    if (type === "allocation") {
      data = {
        allocation: e.value,
      };
    }
    axios
      .put(
        `/sellingPrices/${sellingPriceId}/solutions/${sellingPriceItemSolutionId}`,
        data
      )
      .then((response) => {
        setIsRefreshQuoteData(true);
      })
      .catch((error) => handleApiError(error));
  };

  const getComapnyId = (solutionData) => {
    return parseInt(solutionData?.priceType, 10) === 3
      ? solutionData?.haulier?.companyId
      : solutionData?.centre?.companyId;
  };

  return (
    <OuterDiv>
      <GridRow gap="0rem;">
        <GridRow
          column={
            parseInt(koStatus, 10) === 0 && isStudyTeamType > 0
              ? "10% 15% 15% 19% 7% 10% 10% 10% 4%"
              : "10% 15% 15% 20% 10% 10% 10% 10%"
          }
          gap="0rem;"
        >
          <GridLabel borderRadius="4px 0px 0px 0px">{t("SOLUTION")}</GridLabel>
          <GridLabel textAlign="left">{t("CENTRE")}</GridLabel>
          <GridLabel textAlign="left">{t("PRODUCT")}</GridLabel>
          <GridLabel textAlign="left">{t("PRICE")}</GridLabel>
          <GridLabel>&nbsp;</GridLabel>
          <GridLabel>{t("SOLUTION_MARGIN")}</GridLabel>
          <GridLabel>{t("SOLUTION_STATUS")}</GridLabel>
          <GridLabel
            borderRadius={
              parseInt(koStatus, 10) === 0 && isStudyTeamType > 0
                ? "0px 0px 0px 0px"
                : "0px 4px 0px 0px"
            }
          >
            {t("SOLUTION_ALLOCATION")}
          </GridLabel>
          {parseInt(koStatus, 10) === 0 && isStudyTeamType > 0 && (
            <GridLabel borderRadius="0px 4px 0px 0px">&nbsp;</GridLabel>
          )}
        </GridRow>
        {solutionList?.length > 0 &&
          solutionList.map((priceSolution, solutionIndex) => {
            return (
              <React.Fragment
                key={
                  "kickoff_quote_solution" + solutionIndex + priceSolution?.id
                }
              >
                {solutionIndex !== 0 && <HorizontalRow />}
                {((parseInt(koStatus, 10) === 0 &&
                  parseInt(priceSolution?.solution.solutionStatus.id, 10) ===
                    7 &&
                  [0, 1].indexOf(priceSolution.koStatus) > -1) ||
                  (parseInt(koStatus, 10) === 1 &&
                    parseInt(priceSolution?.solution.solutionStatus.id, 10) ===
                      7 &&
                    [1, 2].indexOf(priceSolution.koStatus) > -1)) && (
                  <GridRow
                    column={
                      parseInt(koStatus, 10) === 0
                        ? "10% 15% 15% 20% 7% 10% 10% 7% 6%"
                        : "10% 15% 15% 20% 10% 10% 10% 10%"
                    }
                    gap="0rem;"
                    backgroundColor="#fff;"
                  >
                    <GridSubLabel fontWeight="700" color="#0A4986">
                      <IDButton
                        onClick={() =>
                          editSolution(priceSolution?.solution?.id)
                        }
                      >
                        {"#" + priceSolution?.solution?.id}
                      </IDButton>
                    </GridSubLabel>
                    <GridSubLabel textAlign="left" fontWeight="700">
                      <Anchor
                        target="_blank"
                        rel="noreferrer"
                        url={`/company/view/${getComapnyId(
                          priceSolution?.solution
                        )}/general-info`}
                        className="kickoff-view-solution__link"
                      >
                        {parseInt(priceSolution?.solution?.priceType, 10) === 3
                          ? priceSolution?.solution?.haulier?.companyName
                          : "[" +
                            priceSolution?.solution?.centre?.supplierName +
                            "] " +
                            priceSolution?.solution?.centre?.companyName}
                      </Anchor>
                    </GridSubLabel>
                    <GridSubLabel textAlign="left">
                      {priceSolution?.solution?.centreProduct?.product?.name}
                    </GridSubLabel>
                    <GridSubLabel textAlign="left">
                      <Price solutionData={priceSolution?.solution} />
                    </GridSubLabel>
                    <GridSubLabel>
                      <Comment comment={priceSolution?.solution} />
                    </GridSubLabel>
                    <GridSubLabel color="#004C7F;">
                      {priceSolution?.margin + "%"}
                    </GridSubLabel>
                    <GridSubLabel color="#004C7F;">
                      {parseInt(koStatus, 10) === 1 &&
                      parseInt(priceSolution.koStatus, 10) === 2
                        ? t("SOLUTION_STATUS_VALIDATED_OUT_KO")
                        : "-"}
                    </GridSubLabel>
                    <GridSubLabel>
                      {parseInt(koStatus, 10) === 0 && (
                        <>
                          {[0, 1].indexOf(priceSolution.koStatus) > -1 && (
                            <Dropdown
                              label=""
                              labelStyles={{
                                display: "none",
                              }}
                              name={
                                parseInt(priceSolution.id) +
                                "_" +
                                parseInt(priceSolution.solution.id, 10) +
                                "_" +
                                t("KICKOFF_Allocation")
                              }
                              value={
                                priceSolution?.koAllocation
                                  ? priceSolution?.koAllocation
                                  : priceSolution?.allocation
                              }
                              defaultOption={t("NONE_SELECTED")}
                              // defaultOption={0}
                              containerStyles={{ width: "auto", lineHeigth: 1 }}
                              inputStyles={{
                                border: "1px solid #474747",
                                height: "30px",
                              }}
                              options={range(0, 110, 10).map((key) => ({
                                label: `${key}%`,
                                value: key,
                              }))}
                              disabled={checkDisabledStatausOfAllocation(
                                priceSolution.koStatus
                              )}
                              onChange={(e) =>
                                handleSolutionValidate(
                                  e,
                                  "allocation",
                                  priceSolution.id,
                                  null
                                )
                              }
                            />
                          )}
                        </>
                      )}
                      {parseInt(koStatus, 10) === 1 && (
                        <>
                          {parseInt(priceSolution.koStatus, 10) === 1
                            ? priceSolution.koAllocation + "%"
                            : "-"}
                        </>
                      )}
                    </GridSubLabel>
                    {parseInt(koStatus, 10) === 0 && (
                      <GridSubLabel>
                        {isStudyTeamType > 0 &&
                          parseInt(priceSolution.koStatus, 10) === 0 && (
                            <>
                              {combination &&
                              !hesusService?.needProduct &&
                              hesusService?.needTransport ? (
                                <Image
                                  src={greenYesIcon}
                                  alt={t("SOLUTION_ACTION_TOOLTIP_VALIDATE1")}
                                  title={t("SOLUTION_ACTION_TOOLTIP_VALIDATE")}
                                  styles={{
                                    height: "25px",
                                    width: "25px",
                                    marginRight: "5px",
                                    cursor: "pointer",
                                    opacity: ".5",
                                  }}
                                />
                              ) : (
                                <Image
                                  src={greenYesIcon}
                                  disabled
                                  onClick={(e) =>
                                    handleSolutionValidate(
                                      e,
                                      "validate",
                                      priceSolution.id,
                                      priceSolution?.koAllocation
                                        ? priceSolution?.koAllocation
                                        : priceSolution?.allocation
                                    )
                                  }
                                  alt={t("SOLUTION_ACTION_TOOLTIP_VALIDATE")}
                                  title={t("SOLUTION_ACTION_TOOLTIP_VALIDATE")}
                                  styles={{
                                    height: "25px",
                                    width: "25px",
                                    marginRight: "5px",
                                    cursor: "pointer",
                                  }}
                                />
                              )}
                            </>
                          )}
                        {isStudyTeamType > 0 &&
                          parseInt(priceSolution.koStatus, 10) === 1 && (
                            <>
                              {combination &&
                              !hesusService?.needProduct &&
                              hesusService?.needTransport ? (
                                <Image
                                  src={cancelIcon}
                                  alt={t("SOLUTION_ACTION_TOOLTIP_UNVALIDATE")}
                                  title={t(
                                    "SOLUTION_ACTION_TOOLTIP_UNVALIDATE"
                                  )}
                                  styles={{
                                    height: "25px",
                                    width: "25px",
                                    marginRight: "5px",
                                    cursor: "pointer",
                                    opacity: ".5",
                                  }}
                                />
                              ) : (
                                <Image
                                  src={cancelIcon}
                                  onClick={(e) =>
                                    handleSolutionValidate(
                                      e,
                                      "invalidate",
                                      priceSolution.id,
                                      priceSolution?.koAllocation
                                        ? priceSolution?.koAllocation
                                        : priceSolution?.allocation
                                    )
                                  }
                                  alt={t("SOLUTION_ACTION_TOOLTIP_UNVALIDATE")}
                                  title={t(
                                    "SOLUTION_ACTION_TOOLTIP_UNVALIDATE"
                                  )}
                                  styles={{
                                    height: "25px",
                                    width: "25px",
                                    marginRight: "5px",
                                    cursor: "pointer",
                                    opacity: ".5",
                                  }}
                                />
                              )}
                            </>
                          )}
                      </GridSubLabel>
                    )}
                  </GridRow>
                )}
              </React.Fragment>
            );
          })}
      </GridRow>
      {isSolutionViewPopupVisible && (
        <SolutionView
          onClose={onSolutionViewClose}
          id={currentSolution.id}
          solutionData={currentSolution}
          // onEdit={editSolution}
          isEditBtnVisible={false}
        />
      )}
    </OuterDiv>
  );
};

Solutions.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation()(Solutions);
